import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { parseLang, type Lang } from "@majourneys/shared";
import { blogApi } from "../api/blog.api";
import { blogKeys } from "../constants/query-keys";

export function recentPostsQueryOptions(lang: Lang) {
  return queryOptions({
    queryKey: blogKeys.recent(lang),
    queryFn: () => blogApi.recentPosts(lang),
  });
}

export function useRecentPosts() {
  const { lang } = useParams({ strict: false }) as { lang?: string };
  return useSuspenseQuery(recentPostsQueryOptions(parseLang(lang)));
}
